<template>
  <div class="yield">
    <div style="width: 100%; height: 100%" ref="myChart" class="pie_item"></div>
  </div>
</template>

<script>
export default {
  name: "Yield",
  data() {
    return {
      dataYear: [],
      datas: [],
    };
  },
  mounted() {
    let timer = setInterval(() => {
      if (this.$url.length > 0) {
        clearInterval(timer);
      }
      this.$axios.get(`${this.$url}${this.$apiObj.yield}`).then((res) => {
        let datas = res.data.data;
        this.dataYear = datas.rows.map((item) => item[0].split("T")[0]);
        this.datas = datas.rows.map((item) => item[1]);
        let myEcharts = this.$echarts.init(this.$refs.myChart);
        let option = {
          grid: {
            left: "0",
            right: "0",
            bottom: "0",
            top: "10",
            containLabel: true,
          },
          tooltip: {
            // trigger: "axis",
          },
          xAxis: {
            data: this.dataYear,
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
          yAxis: {
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },

          // dataZoom: [
          //   {
          //     startValue: "2014-06-01",
          //   },
          //   {
          //     type: "inside",
          //   },
          // ],
          series: {
            name: "产量",
            type: "line",
            data: this.datas,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#fff",
                },
              },
            },
          },
        };

        if (this.datas.length > 0) {
          setTimeout(() => {
            myEcharts.setOption(option);
          }, 5000);
        }
      });
    });
  },
};
</script>

<style lang="less">
.yield {
  width: 100%;
  height: 100%;
}
</style>